import { ComponentProps } from 'react';
import { useComponentProps } from '@optimus-web/common';
import { ButtonType } from '../Button';
import { extractAriaProps } from '../utils/extractAriaProps';
import { SplitButtonContainer, SplitButtonDropdown, SplitButtonWrapper } from './style';
import { SplitButtonVariant } from './types';

export interface SplitButtonProps extends Omit<ComponentProps<typeof SplitButtonContainer>, 'variant'> {
    label?: React.ReactNode;
    children?: React.ReactNode;
    variant?: SplitButtonVariant;
    type?: ButtonType;
}

export const SplitButton = ({
    children,
    disabled,
    label,
    size: customSize,
    variant,
    type = 'button',
    ...other
}: SplitButtonProps) => {
    const { size } = useComponentProps('Button', { size: customSize });
    const [ariaProps, restProps] = extractAriaProps(other);

    return (
        <SplitButtonWrapper variant={variant}>
            <SplitButtonContainer disabled={disabled} variant={variant} size={size} type={type} {...restProps}>
                {label}
            </SplitButtonContainer>
            <SplitButtonDropdown disabled={disabled} variant={variant} size={size} {...ariaProps}>
                {children}
            </SplitButtonDropdown>
        </SplitButtonWrapper>
    );
};
